import { USER_STATUS, USER_STATUS_ERROR_DATA, USER_STATUS_HIDE_ERROR_DATA, USER_STATUS_START_LOADER, USER_STATUS_STOP_LOADER, } from "../interface/IUserStatus";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const UserStatus = (state = initState, action) => {
    switch (action.type) {
        case USER_STATUS: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case USER_STATUS_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case USER_STATUS_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case USER_STATUS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case USER_STATUS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default UserStatus;
